import React, { useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";

const StatusBadge = ({ status }) => {
  const normalized = (status || "Open").toUpperCase();
  const isClosed = normalized === "CLOSED";

  return (
    <span
      className={`badge ${isClosed ? "bg-danger" : "bg-success"}`}
      style={{ minWidth: "72px" }}
    >
      {isClosed ? "Closed" : "Open"}
    </span>
  );
};

const ERFExtensionAccessoriesSection = ({
  rentItems = [],
  nursingItems = [],
  accessoryItems = [],
}) => {
  const eligibleParents = useMemo(() => {
    return [...rentItems, ...nursingItems].filter(
      (item) =>
        !item?.isTotal &&
        item?.accessories === true &&
        Array.isArray(item?.accessoriesCode) &&
        item.accessoriesCode.length > 0,
    );
  }, [rentItems, nursingItems]);

  const groupedAccessories = useMemo(() => {
    const map = new Map();

    eligibleParents.forEach((parent) => {
      map.set(parent.local_id, {
        parent,
        accessories: accessoryItems.filter(
          (acc) => acc.parentLocalId === parent.local_id,
        ),
      });
    });

    return Array.from(map.values());
  }, [eligibleParents, accessoryItems]);

  const columns = useMemo(
    () => [
      {
        name: "Accessory Code",
        width: "150px",
        cell: (row) => (
          <span className="fw-bold">{row.materialCode || "--"}</span>
        ),
      },
      {
        name: "Accessory Description",
        width: "250px",
        cell: (row) => (
          <span className="mt-3 mb-3">
            {row.materialDescription || "--"}
          </span>
        ),
      },
      {
        name: "Barcode",
        width: "200px",
        cell: (row) => <span className="fw-bold">{row.barcode || "--"}</span>,
      },
      {
        name: "Parent Product Code",
        width: "200px",
        cell: (row) => (
          <div>
            <p className="fw-bold">
              {row.parentMaterialCode || "--"}
            </p>
          </div>
        ),
      },
       {
        name: "Parent Item",
        width: "250px",
        cell: (row) => (
          <div>
            <p className="">
              {row.parentDescription || "--"}
            </p>
          </div>
        ),
      },
      {
        name: "Status",
        width: "120px",
        // center: true,
        style: { justifyContent: "center" },
        cell: (row) => <StatusBadge status={row.extensionStatus || "Open"} />,
      },
    ],
    [],
  );

  if (groupedAccessories.length === 0) return null;

  return (
    <div className="accordion mb-4" id="accordionExtensionAccessories">
      <div className="accordion-item">
        <h2 className="accordion-header">
          <Row className="accordion-button">
            <Col xs={1} className="text-left arrowBtn">
              <i className="bi bi-paperclip" />
            </Col>
            <Col xs={1} className="text-center logoBtn">
              <span className="iconLogo">AC</span>
            </Col>
            <Col xs={10}>
              <span className="headerTitle">Accessories</span>
              <span className="subHeaderTitle">
                Accessories inherit status from parent rent / nursing item
              </span>
            </Col>
          </Row>
        </h2>

        <div className="accordion-collapse collapse show visible">
          <div className="accordion-body">
            {groupedAccessories.map(({ parent, accessories }) => (
              <div
                key={parent.local_id}
                className="border rounded mb-4 overflow-hidden"
              >
                <div className="d-flex justify-content-between align-items-center bg-light p-2 border rounded-top">
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    <span className="fw-bold text-primary p-2">
                      {parent.materialCode}
                    </span>
                    <span className="text-dark">
                      {parent.materialDescription}
                    </span>
                  </div>
                  {/* <StatusBadge status={parent.extensionStatus || "Open"} /> */}
                </div>

                {accessories.length > 0 ? (
                  <DataTable
                    columns={columns}
                    data={accessories}
                    noDataComponent={null}
                  />
                ) : (
                  <div className="text-center py-4 text-muted small">
                    No accessories linked to this item.
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ERFExtensionAccessoriesSection;
